import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "chat-tool" }
const _hoisted_2 = ["accept"]
const _hoisted_3 = ["src", "onClick"]

import UploadUtils from "../../utils/UploadUtils";
import { ref } from "vue";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'FileUpload',
  props: {
    rid: null
  },
  setup(__props: any) {

const props = __props as {
  rid: string;
};

const $store = useStore();
let toolList: string[] = [
  require("@/assets/images/toolIcon/img.png"),
  require("@/assets/images/toolIcon/file.png"),
];
const accept = ref<string>("");
// eslint-disable-next-line no-undef

const upload = (index: number): void => {
  accept.value = index == 0 ? "image/*" : "";
  setTimeout(() => {
    (document.getElementsByClassName("file")[0] as HTMLInputElement).click();
  }, 100);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "file",
      hidden: "",
      class: "file",
      onChange: _cache[0] || (_cache[0] = 
        (e) =>
          _unref(UploadUtils).getFile(
            e,
            _unref($store).state.talk.targetId,
            _unref($store).state.talk.correlationId,
            Number(__props.rid)
          )
      ),
      accept: accept.value,
      multiple: true
    }, null, 40, _hoisted_2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toolList), (item, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("img", {
        src: item,
        alt: "",
        key: index,
        onClick: ($event: any) => (upload(index))
      }, null, 8, _hoisted_3)), [
        [_vShow, _unref($store).state.talk.serviceExpireTime[props.rid] != 11]
      ])
    }), 128))
  ]))
}
}

})